import { createStore } from "satcheljs";
import { MSTeamPickerPaneStore } from "./schema/MSTeamPickerPaneStore";
import { IMsTeamWithScheduleInfo } from "sh-models";

/**
 * Team picker pane view state
 */
const initialMSTeamPickerPaneStore: MSTeamPickerPaneStore = {
    isDataLoading: false,                                               // true if data is currently being loaded
    msTeamsWithoutActiveSchedules: new Array<IMsTeamWithScheduleInfo>() // MS Teams without active schedules (may have restorable ones)
};

// let msTeamPickerPaneStore = createStore("msTeamPickerPaneStore", initialMSTeamPickerPaneStore)();

let msTeamPickerPaneStore = createStore<MSTeamPickerPaneStore>(
    "msTeamPickerPaneStore",
    initialMSTeamPickerPaneStore);

export default msTeamPickerPaneStore;

/* export actions and mutator actions for ease of import */
export { default as setIsTeamPickerPaneDataLoading } from "../mutatorActions/setIsTeamPickerPaneDataLoading";
export { default as setMsTeamWithScheduleInfos } from "../mutatorActions/setMsTeamsWithScheduleInfos";
